import { useEffect, useState } from "react";
import { X, ArrowRight } from "@phosphor-icons/react";

const INTAKE_URL = "/intake";
const STORAGE_KEY = "sws_exit_shown";
const MOBILE_DELAY_MS = 30000;

export default function ExitIntent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.sessionStorage.getItem(STORAGE_KEY)) return;

    const isTouch = window.matchMedia("(hover: none)").matches || "ontouchstart" in window;

    const trigger = () => {
      if (window.sessionStorage.getItem(STORAGE_KEY)) return;
      window.sessionStorage.setItem(STORAGE_KEY, "1");
      setOpen(true);
    };

    let timer;
    const onLeave = (e) => {
      if (e.clientY <= 0 && e.relatedTarget == null) trigger();
    };

    if (isTouch) {
      timer = setTimeout(trigger, MOBILE_DELAY_MS);
    } else {
      document.addEventListener("mouseout", onLeave);
    }

    return () => {
      if (timer) clearTimeout(timer);
      document.removeEventListener("mouseout", onLeave);
    };
  }, []);

  if (!open) return null;
  return (
    <div
      data-testid="exit-intent-modal"
      className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/80 backdrop-blur-sm"
      onClick={() => setOpen(false)}
    >
      <div
        className="relative max-w-lg w-full bg-[#0F0F0F] border border-[#FF1B91] p-8 lg:p-10"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="exit-intent-close"
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 text-white/50 hover:text-white"
          aria-label="Close"
        >
          <X size={20} weight="bold" />
        </button>
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#FF1B91] font-semibold mb-4">Before you go —</p>
        <h3 className="font-display font-black uppercase text-3xl tracking-tighter leading-[0.95] mb-4">
          Not sure which tier fits?
        </h3>
        <p className="text-white/75 leading-relaxed mb-6">
          Take the 15-minute intake. I&apos;ll match you with the right level of support — no pressure.
        </p>
        <a
          href={INTAKE_URL}
          target="_blank"
          rel="noreferrer noopener"
          data-testid="exit-intent-cta"
          className="inline-flex items-center gap-3 bg-[#FF1B91] hover:bg-[#FF3FA3] text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] btn-brutal btn-brutal-pink"
        >
          Take the intake <ArrowRight size={14} weight="bold" />
        </a>
        <button
          onClick={() => setOpen(false)}
          className="block mt-5 text-[11px] uppercase tracking-[0.25em] text-white/40 hover:text-white"
        >
          No thanks, just browsing →
        </button>
      </div>
    </div>
  );
}
